import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import { isEmpty } from 'helpers/verify';
import { Selector } from 'components/Selector/Selector';
import { AUTO_RADIUS_ID } from '../../Search.constants';
import { RadiusFilterOptionsContainer } from '../../filters/RadiusFilterOptionsContainer';
import { radiusDefaultLabel } from '../../filters/filters.messages';

class RadiusFilter extends PureComponent {
  componentDidUpdate(prevProps) {
    const { selectedRadius, loadRadius, isAutoLocationAvailable } = this.props;
    const recievedLocation = isAutoLocationAvailable && !prevProps.isAutoLocationAvailable;
    const needUpdateAutoRadius = selectedRadius && selectedRadius.id === AUTO_RADIUS_ID && recievedLocation;

    if (needUpdateAutoRadius || !selectedRadius) {
      loadRadius();
    }
  }

  handleToggleExpanded = () => {
    const { isEditing, onSetIsEditing } = this.props;

    onSetIsEditing(!isEditing);
  };

  renderSelectedRadius = () => {
    const { intl, selectedRadius } = this.props;

    if (selectedRadius) {
      if (selectedRadius.id === AUTO_RADIUS_ID) {
        return radiusDefaultLabel;
      }
      return intl.formatMessage(selectedRadius.defineMessage, { radius: selectedRadius.radius });
    }
  };

  render() {
    const { items, isMobile, isSelected, isEditing } = this.props;

    return (
      <Selector isMobile={isMobile} isSelected={isSelected} onToggle={this.handleToggleExpanded} isOpen={isEditing}>
        {({ DisclosureArrow, Panel, Selection }) =>
          !isEmpty(items) && (
            <div className="unified-filters__filter">
              <Selection>
                {this.renderSelectedRadius()}
                <DisclosureArrow />
              </Selection>
              <Panel onClose={this.handleToggleExpanded} className="unified-filters__filter__panel--align-right">
                <RadiusFilterOptionsContainer excludeFromWriteActions={false} isResetEditAfterChange />
              </Panel>
            </div>
          )
        }
      </Selector>
    );
  }
}

const radiusItemShape = PropTypes.shape({
  defineMessage: PropTypes.any.isRequired,
  id: PropTypes.number.isRequired,
  radius: PropTypes.string,
  value: PropTypes.number.isRequired,
});

RadiusFilter.propTypes = {
  isMobile: PropTypes.bool,
  items: PropTypes.arrayOf(radiusItemShape),
  loadRadius: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  selectedRadius: radiusItemShape,
  isSelected: PropTypes.bool,
  isAutoLocationAvailable: PropTypes.bool,
  onSetIsEditing: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

export { RadiusFilter };
